import moment from "moment"

export function toggleTableScroll(wrapperClass: string, overflow: string) {
  const wrappedResult: any = document.querySelectorAll(`.${wrapperClass}, .ant-table-body`)
  let wrapperIndex = null
  for (let i = 0; i < wrappedResult.length; i++) {
    if (wrappedResult[i].className.includes(wrapperClass)) {
      wrapperIndex = i
    }
  }

  if (wrapperIndex) wrappedResult[wrapperIndex + 1].style.overflow = overflow
}

export function saveToFileSystem(response: any, name: string = 'newfile', fileType: string = 'xlsx'): void {
  downloadFile(response, `${name}.${fileType}`)
}

export function downloadFile(file: Blob, filename: string): void {
  const blob = new Blob([file], { type: 'application/octet-stream' })
  const link = document.createElement('a')
  document.body.appendChild(link)
  link.href = window.URL.createObjectURL(blob)
  link.setAttribute('download', filename)
  link.click()
  document.body.removeChild(link)
}

export function swapElements(arr: any[], x: number, y: number): any[] {
  const temp = arr[x]

  arr[x] = arr[y]

  arr[y] = temp

  return arr
}

export function haveValue(value: any): boolean {
  if (value === undefined || value === null || value === '') {
    return false
  }
  return true
}

export function identify(index: number, item: any) {
  return item?.id
}

/**
 * Lấy ngày đầu của tuần thứ nhất và ngày cuối tuần thứ hai (2 tuần mới nhất tính từ tuần hiện tại).
 * - Nếu tuần hiện tại và tuần tiếp theo đều nằm trong tháng => lấy tuần hiện tại + tuần tiếp theo.
 * - Nếu tuần tiếp theo vượt quá tháng hiện tại => lấy tuần trước + tuần hiện tại.
 * @returns { startOfWeek: moment.Moment, endOfNextWeek: moment.Moment }
 */
export function getStartAndEndOfTwoRecentWeeks(current?: moment.Moment) {
  const now = (current ? current.clone() : moment()).hour(0).minute(0).second(0).millisecond(0)

  const year = now.year()
  const month = now.month() // 0-based

  // Tuần hiện tại
  const thisWeekStart = now.clone().startOf('isoWeek') // Monday
  const thisWeekEnd = now.clone().endOf('isoWeek')     // Sunday

  // Tuần tiếp theo
  const nextWeekStart = thisWeekStart.clone().add(1, 'week')
  const nextWeekEnd = thisWeekEnd.clone().add(1, 'week')

  // Kiểm tra tuần tiếp theo có nằm trong tháng không
  if (nextWeekEnd.month() === month) {
    // Tuần hiện tại + tuần tiếp theo
    return {
      startOfWeek: current || thisWeekStart,
      endOfNextWeek: nextWeekEnd
    }
  } else {
    // Tuần trước + tuần hiện tại
    const prevWeekStart = thisWeekStart.clone().subtract(1, 'week')
    return {
      startOfWeek: prevWeekStart,
      endOfNextWeek: thisWeekEnd
    }
  }
}

export function range(from: number, to: number): number[] {
  return Array.from({ length: to - from + 1 }, (_, i) => from + i)
}

export function getPlayerDisplay(list: any[]): string {
  if (!list || list.length === 0) return ''
  // Lấy tên đầu tiên, giới hạn 6 ký tự và thêm ...
  const first = list[0]?.fullName || list[0]?.playerName || list[0]?.name || list[0]?.employeeName || list[0] || ''
  const firstDisplay = first.length > 8 ? (first.slice(0, 8) + '...') : first
  // Nếu chỉ có 1 item, trả về tên đã xử lý
  if (list.length === 1) return firstDisplay
  // Nếu có nhiều hơn 1 item, trả về tên đầu +,+số lượng còn lại
  return `${firstDisplay},+${list.length - 1}`
}
